import { formatOpenRouterUsd } from "@/lib/ai/openrouter-balance-view";
import type { AiSpendCurrency } from "@/lib/ai/spend-cost";

export function formatSpendRub(value: number): string {
  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);
  const rounded = Math.round(abs * 100) / 100;
  const [whole = "0", frac = "00"] = rounded.toFixed(2).split(".");
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  if (frac === "00") {
    return `${sign}₽${grouped}`;
  }
  return `${sign}₽${grouped}.${frac}`;
}

export function formatSpendAmount(
  amount: number,
  currency: AiSpendCurrency,
): string {
  return currency === "RUB"
    ? formatSpendRub(amount)
    : formatOpenRouterUsd(amount);
}

export function formatSpendTotal(
  usd: number,
  rub: number,
  empty: AiSpendCurrency = "USD",
): string {
  const parts: string[] = [];
  if (usd > 0) {
    parts.push(formatSpendAmount(usd, "USD"));
  }
  if (rub > 0) {
    parts.push(formatSpendAmount(rub, "RUB"));
  }
  if (parts.length === 0) {
    return formatSpendAmount(0, empty);
  }
  return parts.join(" + ");
}

export function splitSpendFigure(value: string): {
  sign: "" | "-";
  currency: "$" | "₽" | null;
  amount: string;
} {
  let rest = value;
  let sign: "" | "-" = "";
  if (rest.startsWith("-")) {
    sign = "-";
    rest = rest.slice(1);
  }
  if (rest.startsWith("$") || rest.startsWith("₽")) {
    return {
      sign,
      currency: rest[0] as "$" | "₽",
      amount: rest.slice(1),
    };
  }
  return { sign: "", currency: null, amount: value };
}
